export default __webpack_public_path__ + "static/media/PANEL_2_LOGOS.29a63c20.png";